import t from "react";
import { translate as e } from "@aws-amplify/ui";
import { useAuthenticator as n } from "../hooks/useAuthenticator/index.js";
import { Button as i } from "../../../primitives/Button/Button.js";
import { Flex as o } from "../../../primitives/Flex/Flex.js";

var r = function r(_r) {
  var m = _r.cancelButtonSendType,
      a = _r.cancelButtonText,
      l = _r.submitButtonText,
      _n = n(function (t) {
    return [t.isPending];
  }),
      s = _n._send,
      u = _n.isPending,
      c = u ? t.createElement(t.Fragment, null, e("Submitting"), "…") : t.createElement(t.Fragment, null, e("Submit")),
      p = l || c;

  return t.createElement(o, {
    direction: "column"
  }, t.createElement(i, {
    fontWeight: "normal",
    variation: "primary",
    isDisabled: u,
    type: "submit"
  }, p), t.createElement(i, {
    onClick: function onClick() {
      return s({
        type: m
      });
    },
    type: "button",
    variation: "link",
    fontWeight: "normal",
    size: "small"
  }, a));
};

export { r as TwoButtonSubmitFooter };